// Module
var code = " <login-header [hasGreenBg]=\"true\" [hasTitle]=\"true\" [title]=\"'Συχνές ερωτήσεις'\" [isLogin]=\"false\"></login-header> <common-questions-section></common-questions-section> ";
// Exports
module.exports = code;